export const modalStyles = `
:host {
  --cmp-z-index: 2147483000;
  --cmp-settings-inline: 20px;
  --cmp-settings-block: 20px;
  all: initial;
  color-scheme: light dark;
  font-family: "Avenir Next", "Segoe UI", sans-serif;
  font-size: 14px;
  line-height: 1.5;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
}
*, *::before, *::after { box-sizing: border-box; }
button, input, select, a { font: inherit; }
button, select { cursor: pointer; }
button:disabled { cursor: wait; opacity: .62; }
::selection { color: var(--cmp-primary-text); background: var(--cmp-primary); }
.cmp-overlay {
  position: fixed;
  inset: 0;
  z-index: var(--cmp-z-index);
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--cmp-overlay);
  opacity: 0;
  visibility: hidden;
  transition: opacity 180ms, visibility 180ms;
}
.cmp-overlay[data-open="true"] { opacity: 1; visibility: visible; }
.cmp-overlay[data-mode="banner"] {
  place-items: end center;
  background: transparent;
  pointer-events: none;
}
.cmp-overlay[data-mode="banner"] .cmp-dialog {
  width: min(100%, 760px);
  pointer-events: auto;
}
.cmp-dialog {
  width: min(100%, 620px);
  max-height: min(82vh, 640px);
  max-height: min(82dvh, 640px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  color: var(--cmp-text);
  background: var(--cmp-background);
  border-radius: 16px;
  box-shadow: 0 2px 6px rgb(0 0 0 / .10), 0 12px 40px rgb(0 0 0 / .20);
  transform: translateY(12px);
  transition: transform 200ms cubic-bezier(.16,1,.3,1);
}
.cmp-overlay[data-open="true"] .cmp-dialog { transform: translateY(0); }
.cmp-dialog:focus { outline: none; }
.cmp-header {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 20px 24px 8px;
}
.cmp-title {
  min-width: 0;
  flex: 1;
  margin: 0;
  color: var(--cmp-text);
  font-size: 19px;
  line-height: 1.3;
  font-weight: 650;
  letter-spacing: -.015em;
  text-wrap: balance;
  overflow-wrap: anywhere;
}
.cmp-close {
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  display: grid;
  place-items: center;
  border: 0;
  border-radius: 8px;
  color: var(--cmp-text);
  background: transparent;
  font-size: 24px;
}
.cmp-tabs {
  flex-shrink: 0;
  display: flex;
  gap: 8px;
  padding: 0 16px;
  border-bottom: 1px solid var(--cmp-border);
}
.cmp-tab {
  position: relative;
  min-height: 44px;
  border: 0;
  padding: 8px;
  color: var(--cmp-muted-text);
  background: transparent;
  font-weight: 600;
}
.cmp-tab[aria-selected="true"] { color: var(--cmp-text); }
.cmp-tab[aria-selected="true"]::after {
  content: "";
  position: absolute;
  inset: auto 8px -1px;
  height: 2px;
  background: var(--cmp-primary);
}
.cmp-body {
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
  padding: 8px 24px 12px;
  scrollbar-color: var(--cmp-border) transparent;
  scrollbar-width: thin;
}
.cmp-panel { min-height: 0; }
.cmp-description {
  margin: 0;
  max-width: 70ch;
  color: var(--cmp-muted-text);
  font-size: 14px;
  line-height: 1.55;
  text-wrap: pretty;
  overflow-wrap: anywhere;
}
.cmp-description + .cmp-description { margin-top: 12px; }
.cmp-information { display: flex; flex-wrap: wrap; gap: 4px 20px; margin-top: 4px; }
.cmp-text-button, .cmp-information .cmp-link {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0;
  border: 0;
  color: var(--cmp-text);
  background: transparent;
  font-size: 13px;
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: var(--cmp-border);
}
.cmp-disclosure-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  min-height: 44px;
  color: var(--cmp-text);
  font-weight: 600;
  cursor: pointer;
  list-style: none;
}
.cmp-disclosure-summary::-webkit-details-marker { display: none; }
.cmp-disclosure-summary::after {
  content: "";
  width: 6px;
  height: 6px;
  flex: 0 0 6px;
  margin-inline: 2px 4px;
  border-right: 1.5px solid currentColor;
  border-bottom: 1.5px solid currentColor;
  transform: rotate(45deg);
}
details[open] > .cmp-disclosure-summary::after { transform: rotate(225deg); }
.cmp-link { color: var(--cmp-primary); font-weight: 600; text-underline-offset: 3px; }
.cmp-language {
  min-height: 44px;
  max-width: 100px;
  border: 0;
  border-radius: 6px;
  padding: 0 4px;
  color: var(--cmp-muted-text);
  background: var(--cmp-background);
  text-transform: uppercase;
}
.cmp-categories { display: grid; }
.cmp-category {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  min-height: 64px;
  padding: 10px 0;
}
.cmp-category + .cmp-category { border-top: 1px solid var(--cmp-border); }
.cmp-category-select {
  display: grid;
  place-items: center;
  width: 44px;
  height: 44px;
  flex: 0 0 44px;
  cursor: pointer;
}
.cmp-checkbox {
  appearance: none;
  position: relative;
  width: 38px;
  height: 22px;
  margin: 0;
  border: 1px solid var(--cmp-toggle-off);
  border-radius: 12px;
  color: var(--cmp-background);
  background: var(--cmp-toggle-off);
  cursor: pointer;
}
.cmp-checkbox::before {
  content: "";
  position: absolute;
  top: 3px;
  inset-inline-start: 3px;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  background: currentColor;
}
.cmp-checkbox:checked { border-color: var(--cmp-primary); background: var(--cmp-primary); }
.cmp-checkbox:checked::before { inset-inline-start: 19px; }
.cmp-checkbox:disabled { opacity: .55; cursor: not-allowed; }
.cmp-category-copy { min-width: 0; flex: 1; }
.cmp-category-title { color: var(--cmp-text); font-weight: 600; overflow-wrap: anywhere; }
.cmp-category-description {
  margin: 0 0 4px;
  color: var(--cmp-muted-text);
  font-size: 14px;
  line-height: 1.5;
  text-wrap: pretty;
  overflow-wrap: anywhere;
}
.cmp-always { color: var(--cmp-muted-text); font-size: 12px; font-weight: 400; }
.cmp-footer {
  flex-shrink: 0;
  padding: 12px 24px calc(20px + env(safe-area-inset-bottom));
  border-top: 1px solid var(--cmp-border);
  background: var(--cmp-background);
}
.cmp-actions { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 8px; }
.cmp-button {
  min-height: 44px;
  border: 1px solid transparent;
  border-radius: 8px;
  padding: 10px 12px;
  font-weight: 600;
  line-height: 1.4;
  overflow-wrap: anywhere;
  transition: background-color 120ms;
}
.cmp-button-primary { color: var(--cmp-primary-text); background: var(--cmp-primary); }
.cmp-button-secondary { color: var(--cmp-text); background: var(--cmp-secondary); }
.cmp-dialog[data-tab="consent"] .cmp-button-secondary {
  color: var(--cmp-text);
  background: transparent;
  text-decoration: underline;
  text-underline-offset: 3px;
  text-decoration-color: var(--cmp-border);
}
.cmp-button:focus-visible, .cmp-close:focus-visible, .cmp-link:focus-visible,
.cmp-language:focus-visible, .cmp-checkbox:focus-visible, .cmp-settings:focus-visible,
.cmp-tab:focus-visible, .cmp-disclosure-summary:focus-visible, .cmp-text-button:focus-visible {
  outline: 2px solid var(--cmp-focus-ring);
  outline-offset: 2px;
}
.cmp-settings {
  position: fixed;
  z-index: var(--cmp-z-index);
  inset-block-end: calc(var(--cmp-settings-block) + env(safe-area-inset-bottom));
  width: 48px;
  height: 48px;
  display: none;
  place-items: center;
  border: 0;
  border-radius: 50%;
  color: var(--cmp-primary-text);
  background: var(--cmp-primary);
  box-shadow: 0 2px 8px rgb(0 0 0 / .16), 0 10px 28px rgb(0 0 0 / .18);
}
.cmp-settings[data-visible="true"] { display: grid; }
.cmp-settings[data-position="none"] { display: none; }
.cmp-settings-icon { width: 24px; height: 24px; }
.cmp-settings[data-position="bottom-left"] { inset-inline-start: var(--cmp-settings-inline); }
.cmp-settings[data-position="bottom-right"] { inset-inline-end: var(--cmp-settings-inline); }
.cmp-visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  overflow: hidden;
  clip: rect(0 0 0 0);
  clip-path: inset(50%);
  white-space: nowrap;
}
@media (hover: hover) and (pointer: fine) {
  .cmp-close:hover, .cmp-tab:hover { background: var(--cmp-secondary); }
  .cmp-button-primary:hover { filter: brightness(.94); }
  .cmp-button-secondary:hover { filter: brightness(.97); }
  .cmp-text-button:hover, .cmp-information .cmp-link:hover,
  .cmp-dialog[data-tab="consent"] .cmp-button-secondary:hover { text-decoration-color: currentColor; }
}
@media (min-width: 641px) {
  .cmp-overlay[data-mode="banner"] .cmp-dialog[data-tab="consent"] {
    display: grid;
    grid-template-columns: minmax(0, 1fr) 208px;
    grid-template-rows: auto minmax(0, 1fr);
    width: min(100%, 940px);
  }
  .cmp-overlay[data-mode="banner"] .cmp-dialog[data-tab="consent"] .cmp-header { grid-column: 1; }
  .cmp-overlay[data-mode="banner"] .cmp-dialog[data-tab="consent"] .cmp-body { grid-column: 1; padding-bottom: 16px; }
  .cmp-overlay[data-mode="banner"] .cmp-dialog[data-tab="consent"] .cmp-footer {
    grid-column: 2;
    grid-row: 1 / 3;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 20px;
    border-top: 0;
    border-inline-start: 1px solid var(--cmp-border);
  }
  .cmp-overlay[data-mode="banner"] .cmp-dialog[data-tab="consent"] .cmp-actions { grid-template-columns: 1fr; }
}
@media (max-width: 640px) {
  .cmp-overlay { padding: 12px; }
  .cmp-overlay[data-mode="banner"] { padding-bottom: max(12px, env(safe-area-inset-bottom)); }
  .cmp-dialog {
    width: 100%;
    max-height: min(calc(100vh - 24px), 640px);
    max-height: min(calc(100dvh - 24px), 640px);
  }
  .cmp-header { padding: 12px 12px 4px; }
  .cmp-title { font-size: 18px; }
  .cmp-tabs { padding-inline: 10px; gap: 0; }
  .cmp-tab { min-width: 0; flex: 1 1 0; overflow-wrap: anywhere; }
  .cmp-body { padding: 8px 12px; }
  .cmp-footer { padding: 8px 12px calc(8px + env(safe-area-inset-bottom)); }
  .cmp-actions { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .cmp-button-secondary { grid-column: 1 / -1; }
  .cmp-dialog[data-tab="consent"] .cmp-button-secondary {
    min-height: 44px;
    padding-block: 8px;
    background: var(--cmp-secondary);
    text-decoration: none;
  }
}
@media (forced-colors: active) {
  .cmp-dialog { border: 1px solid CanvasText; }
  .cmp-checkbox { appearance: auto; width: 22px; accent-color: auto; }
  .cmp-checkbox::before { content: none; }
  .cmp-button { border-color: ButtonText; }
}
@media (prefers-reduced-motion: reduce) {
  .cmp-overlay, .cmp-dialog, .cmp-button { transition: none; }
}
`
